/* unplugin-vue-components disabled */import { render } from "./feed-entities.vue?vue&type=template&id=045cc499&scoped=true"
import script from "./feed-entities.vue?vue&type=script&lang=js"
export * from "./feed-entities.vue?vue&type=script&lang=js"

import "./feed-entities.vue?vue&type=style&index=0&id=045cc499&lang=stylus&scoped=true"
import "./feed-entities.vue?vue&type=style&index=1&id=045cc499&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045cc499"],['__file',"src/pages/pulse/feed/feed-entities.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "045cc499"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('045cc499', __exports__)) {
    api.reload('045cc499', __exports__)
  }
  
  module.hot.accept("./feed-entities.vue?vue&type=template&id=045cc499&scoped=true", () => {
    api.rerender('045cc499', render)
  })

}


export default __exports__